var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"crowdsale-box"},[_c('token-authorizations',{ref:"tokenAuthorizations",attrs:{"tokenBets":_vm.tokenBets,"planType":_vm.tokenAllowanceType}})],1):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a6295ea","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reuse/dialog/authorize/tokenAllowance.vue
// module id = null
// module chunks = 